export enum InitiativeCategory {
  NationalStrategy = 'National – Strategy',
  NationalGovernance = 'National – AI governance bodies or mechanisms',

  IntergovernmentalPolicyFrameworks = 'AI Policy Frameworks and Initiatives (intergovernmental or supranational)',
  IntergovernmentalGovernance = 'AI Governance Bodies and Mechanisms (intergovernmental or supranational)',
  NationalRegulations = 'Regulations, guidelines and standards',
  NationalProgrammes = 'AI policy initiatives, programmes and projects'
}

export enum InitiativeMainCategory {
  Intergovernmental = 'Intergovernmental or supranational',
  National = 'National'
}

export const InitiativeCategoryValues = [
  ...Object.values(InitiativeCategory)
] as const

export type InitiativeCategoryKey = keyof typeof InitiativeCategory

export const getCategoryKey = (
  value: string
): InitiativeCategoryKey | undefined => {
  return Object.keys(InitiativeCategory).find(
    (key) => InitiativeCategory[key as InitiativeCategoryKey] === value
  ) as InitiativeCategoryKey
}

export type InitiativeCategoryValue = (typeof InitiativeCategoryValues)[number]
